<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Disabled">Update Module</v-flex> 
                    <v-flex v-else>Module List</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>    
                </v-card-title>
                <v-card-text>
                    <v-flex wrap>                
                        <v-flex>
                           <span style="font-size: 14px;font-weight: bold;"> Course Title : </span> 
                           <span> {{ Course_Title }} </span>
                        </v-flex>
                    </v-flex>
                    <v-flex>
                        <v-layout row>
                            <v-select @change="SetSelectedSection" item-value='Section_Id' item-text='name' return-object v-model="Selected_Section" :items="Sections" label="Select Section">
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Section_Title }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.Section_Title }}    
                                    </template>
                            </v-select>
                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-radio-group v-model="Update_Type" row @change="FilterTopics">
                            <v-radio label="Module Description" value="Module_Description"></v-radio>
                            <v-radio label="Module Topics" value="Module_Topics"></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex v-if="Update_Type == 'Module_Description'">
                        <v-text-field :disabled='Disabled' v-model="Section_Title" label='Module Title'></v-text-field>
                    </v-flex>
                    <v-flex v-if="Update_Type == 'Module_Description'">
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">Module Description :</v-flex>
                        <vue-editor v-if="!Disabled" id="editor" v-model="Section_Description"></vue-editor>
                        <v-flex style="text-align: justify;" v-else v-html="Section_Description"></v-flex>
                    </v-flex>
                    <v-flex v-else>
                        <v-layout row>
                            <v-select @change="SetSelectedTopic" item-value='Section_Id' item-text='name' return-object v-model="Selected_Topic" :items="Topics" label="Select Module Topic">
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Topic_Title }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.Topic_Title }}    
                                    </template>
                            </v-select>
                        </v-layout>
                        <v-flex>
                            <v-text-field :disabled='Disabled' v-model="Topic_Title" label='Topic Title'></v-text-field>
                        </v-flex>
                         <v-flex>
                            <v-text-field :disabled='Disabled' v-model="Topic_Start_Time" label='Topic Start Time'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field :disabled='Disabled' v-model="Topic_End_Time" label='Topic End Time'></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions v-if="!Disabled">
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="Update_Type == 'Module_Description'" @click="UpdateCurriculamBasedOnType">Update Module Details</v-btn>
                        <v-btn color="success" v-if="Update_Type != 'Module_Description'" @click="UpdateCurriculamBasedOnType">Update Module Topic</v-btn>
                    </v-flex>
                </v-card-actions>
                <v-card-actions v-if="Disabled && Update_Type != 'Module_Description'">
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn :disabled="!Topic_Id" color="error" @click="DeleteTopic">Delete Topic</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Disabled                : false,
            Course_Title            : "",
            Course_Details          : {},
            Sections                : [],
            Selected_Section        : {},
            Course_Type             : "",
            Update_Type             : 'Module_Description',
            Topics                  : [],
            Selected_Topic          : {},
            Topic_Id                : "",
            Topic_Title             : "",
            Topic_End_Time          : "",
            Section_Id              : '',
            Section_Title           : '',
            Section_Description     : '',
        }
    },
    methods:{
        CloseDialog(){

            this.Selected_Section  = {}
            this.Course_Type       = ""
            this.Sections          = []
            this.Course_Title      = ""
            this.Course_Details    = {}
            this.Topics                 = []
            this.Selected_Topic         = {}
            this.Topic_Id               = ""
            this.Topic_Title            = ""
            this.Topic_Start_Time       = ''
            this.Topic_End_Time         = ""
            this.Section_Id             = ''
            this.Section_Title          = ''
            this.Section_Description    = ''
            this.Update_Type            = 'Module_Description'
            this.$emit('close')
        },
        GetCurriculam(Course,Type){
        
            this.Course_Title   = Course["Course_Title"]
            this.Course_Details = Course
            this.Course_Type    = Course['Course_Types'].find(x => x == 'Online') ? true : false
            this.Sections       = Course['Course_Curriculam']
            this.Disabled       = Type == 'Update' ? false : true
        },
        FilterTopics(){
            let Section = this.Sections.find(x => x['Section_Id'] == this.Selected_Section['Section_Id'])

            if(Object.keys(Section).length > 0 && Section['Topics'] && Section['Topics'].length > 0){

                this.Topics = Section['Topics']

            }else{

                this.Topics = []
            }
        },
        SetSelectedTopic(){

            this.Topic_Id         = this.Selected_Topic['Topic_Id']
            this.Topic_Title      = this.Selected_Topic['Topic_Title']
            this.Topic_Start_Time = this.Selected_Topic['Topic_Start_Time']
            this.Topic_End_Time   = this.Selected_Topic['Topic_End_Time']
        },
        SetSelectedSection(){
            
            this.Selected_Topic         = {}
            this.Topic_Id               = ""
            this.Topic_Title            = ""
            this.Topic_Start_Time       = ''
            this.Topic_End_Time         = ""
            this.Update_Type            = 'Module_Description'
            this.Section_Id            = this.Selected_Section['Section_Id']
            this.Section_Title         = this.Selected_Section['Section_Title']
            this.Section_Description   = this.Selected_Section['Section_Description']
        },
        UpdateCurriculamBasedOnType(){

                if(this.Update_Type == 'Module_Description'){

                    this.UpdateCurriculam()

                }else{
                    this.Update_Topic()
                }
        },
        Update_Topic(){

             let data = {}
            data['Course_Id']        = this.Course_Details["Course_Id"]
            data['Section_Id']       = this.Section_Id
            data['Topic_Id']         = this.Topic_Id
            data['Topic_Title']      = this.Topic_Title
            data['Topic_Start_Time'] = this.Topic_Start_Time
            data['Topic_End_Time']   = this.Topic_End_Time

            if(Object.keys(data).length > 2){

                this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/updatemoduletopic`,data)
                            .then(response =>{
                                
                                this.$store.commit('SetCourseCurriculamList',response["data"]["response"])   
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Section Details","Color":"green","Close": false });  
                                this.CloseDialog()
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating Section Details","Color":"red","Close": false });
                            })
            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill The Complete Form Details","Color":"red","Close": false });
            }

        },
        DeleteTopic(){

                let data = {}
                data['Section_Id']  = this.Section_Id
                data['Topic_Id']    = this.Topic_Id
                data['Course_Id']   = this.Course_Details["Course_Id"]
                if(Object.keys(data).length > 2){

                    this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/deletemoduletopic`,data)
                                .then(response =>{
                                    
                                    this.$store.commit('SetCourseCurriculamList',response["data"]["response"])   
                                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Section Details","Color":"green","Close": false });  
                                    this.CloseDialog()
                                })
                                .catch(err =>{
        
                                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating Section Details","Color":"red","Close": false });
                                })
                }else{

                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill The Complete Form Details","Color":"red","Close": false });
                }

        },
        UpdateCurriculam(){

            let data = {}
            data['Section_Id']            = this.Section_Id
            data['Section_Title']         = this.Section_Title
            data['Section_Description']   = this.Section_Description
            data['Course_Id'] = this.Course_Details["Course_Id"]
            if(Object.keys(data).length > 2){

                this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/updatecurriculam`,data)
                            .then(response =>{
                                
                                this.$store.commit('SetCourseCurriculamList',response["data"]["response"])   
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Section Details","Color":"green","Close": false });  
                                this.CloseDialog()
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating Section Details","Color":"red","Close": false });
                            })
            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill The Complete Form Details","Color":"red","Close": false });
            }
        }
    }
}
</script>
<style scoped>
 #editor{
     height: 350px;
 }
</style>